import { useContext, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import api from '../api';
import { UserContext } from '../App';

let _cache = null;
let _promise = null;

export function useLockConfig() {
  const currentUser = useContext(UserContext);
  const [config, setConfig] = useState(() => _cache);

  useEffect(() => {
    // Fetched for every signed-in user. While this was admin-only the config
    // stayed null for everyone else, so checkLocked always returned false and
    // the lock applied to admins alone.
    if (!currentUser) return;
    if (_cache) { setConfig(_cache); return; }
    if (!_promise) {
      _promise = api.get('/api/admin/lock-config').then((r) => {
        _cache = r.data;
        return r.data;
      }).catch(() => null);
    }
    _promise.then((data) => { if (data) setConfig(data); }).catch(() => {});
  }, [currentUser]);

  return config;
}

// Returns true when refDate is strictly before lockBeforeDate (null = no lock).
export function checkLocked(config, objType, refDate) {
  if (!config || !refDate) return false;
  const lockBefore = config[objType];
  if (!lockBefore) return false;
  return dayjs(refDate).isBefore(dayjs(lockBefore), 'day');
}
